module.exports = __webpack_public_path__ + "static/media/step3.00a3093b.png";